import { Title } from "../../Atoms/Title";
import { FormCollaboratorEdit } from "../../Molecules/FormCollaboratorEdit";
import * as S from "./styles";
import { useCollaboratorDetail } from "./useCollaboratorDetail";

export const CollaboratorDetailTemplate = () => {
  const { handleSubmit } = useCollaboratorDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Colaborador</Title>
        <FormCollaboratorEdit submitForm={handleSubmit} />
      </S.Wrapper>
    </S.Container>
  );
};
